import React, { PureComponent } from 'react';

import Card from '@bit/wavfichacerta.fichacerta.cards.card';
import { StyledRow } from '@bit/wavfichacerta.fichacerta.shared-styles.rows';
import { BaseColumn } from '@bit/wavfichacerta.fichacerta.shared-styles.columns';
import { CardText, CardButton, Subtitle } from './operational.styles';
import { formatToBRL } from '../../utils/formatter'
import CustomTolltip from '@bit/wavfichacerta.fichacerta.tooltip.custom-tooltip';
import Edit from '@bit/wavfichacerta.fichacerta.icons.edit';
import styled, { createGlobalStyle } from 'styled-components'
import TourTooltip from '../shared/TourTooltip';
import { ApplicantMobileIconBtn } from './applicantCard.styles';

const GlobalStyle = createGlobalStyle`
  @media (max-width: 800px) {
    .hidden-in-mobile {
      display: none !important;
    }
  }
`

const StyledRealtyCard = styled(Card)`
  position: relative;
  border: 1px solid rgba(21, 43, 78, 0.1);
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 4px 18px rgba(21, 43, 78, 0.08);

  .realty-address {
    width: 100%;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .wrapper-box-info {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: stretch;
    padding-top: 6px;

    .box-info {
      min-width: 0;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 2px;
    }

    .lateral-bar {
      display: none;
    }

    ${Subtitle} {
      font-size: 11px;
      font-weight: 600;
      color: #64748b;
      letter-spacing: .02em;
      text-transform: uppercase;
    }

    .realty-info-value {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: block;
      min-width: 0;
      margin-left: 0 !important;
      color: #152b4e;
      font-size: 14px;
      font-weight: 600;
    }
  }

  @media (max-width: 800px) {
    box-shadow: none;
    border: 0;
    border-radius: 0;
    padding: 0;
    margin: 0;

    .realty-address {
      font-size: 13px !important;
      line-height: 1.35;
      color: #152b4e !important;
      padding: 2px 56px 0 2px;
      white-space: normal;
      overflow: visible;
      text-overflow: clip;
    }

    .wrapper-box-info {
      display: grid;
      grid-template-columns: 1fr;
      gap: 12px;
      padding-top: 12px;
      align-items: start;

      .box-info {
        min-width: 0;

        ${Subtitle} {
          font-size: 10px;
          font-weight: 600;
          color: #64748b;
          letter-spacing: 0.04em;
        }

        ${CardText} {
          margin-left: 0 !important;
          margin-top: 2px !important;
          font-size: 13px !important;
          font-weight: 700 !important;
          color: #152b4e !important;
        }
      }

      .lateral-bar {
        display: none;
      }
    }
  }
`

class RealtyCard extends PureComponent {
  getLocationValue = () => {
    const { aluguel, iptu, condominio } = this.props.infos.locacao;
    const rent = parseFloat(aluguel) || 0;
    const tax = parseFloat(iptu) || 0;
    const fee = parseFloat(condominio) || 0;
    const total = `R$ ${formatToBRL(rent + fee + tax)}`

    return total;
  }

  get addressNumber() {
    const { address } = this.props;
    if (address !== undefined && typeof address === "object") {
      const { numero } = this.props.address;
      return (numero !== null && numero !== undefined) ? `, ${numero}` : "";
    }
    return "";
  }

  get address() {
    const { address } = this.props;
    if (address !== undefined && typeof address === "object") {
      const { logradouro } = this.props.address;
      return (logradouro !== null && logradouro !== undefined) ? `${logradouro} ` : "";
    }
    return "";
  }

  get extra() {
    const { address } = this.props;
    if (address !== undefined && typeof address === "object") {
      const { complemento } = this.props.address;
      return (complemento !== null && complemento !== undefined) ? ` - ${complemento}` : "";
    }
    return "";
  }

  get fullAddress() {
    return (this.address + this.addressNumber + this.extra) || 'Não informado';
  }

  get propertyCode() {
    const { locacao } = this.props.infos;
    return locacao.codigo_imovel || 'Não informado';
  }

  tipoDeImovel() {
    const { locacao } = this.props.infos;

    

    switch(locacao.tipo_imovel) {
      case('NAO_RESIDENCIAL'):
        return 'Não Residencial'
      default:
        return locacao.tipo_imovel || 'Não informado'
    }
  }

  handleOcultado = (text) => {
    const pretendentes = this.props.infos.pretendentes
    const allOculto = pretendentes.every((pretendente) => Boolean(pretendente.oculto) === true);
    if(allOculto) {
      if(!text) {
        return true;
      }
      return 'OCULTADO';
    }
    return text;
  }


  render() {
    
    return (
      <StyledRealtyCard className="request-resume-realty-card" padding=".5rem">
        <GlobalStyle />
        <TourTooltip
          target="tooltip-editar-locacao"
          style={{ top: -10, right: -10, zIndex: 4 }}
        />
        <StyledRow align="flex-end" margin="0 0 .5rem 0">
          <BaseColumn md={10} lg={10} xl={10}>
            <CustomTolltip
              message={this.handleOcultado(this.fullAddress)}
              position="bottom-end"
              target="reqestAddress"
              innerstyle="width: 13rem; height: auto!important;"
              customstyle="opacity: 1 !important"
            >
              <CardText
                id="reqestAddress"
                className="realty-address"
                color="color_purple"
                title={this.handleOcultado(this.fullAddress)}
                customstyle='@media (max-width: 800px) {font-size: 12px;color: #7f7f7f;}'
              >
                {this.handleOcultado(this.fullAddress)}
              </CardText>
            </CustomTolltip>
          </BaseColumn>
          <BaseColumn
            customstyle="
              align-self: flex-start;
              
              @media(max-width: 800px) {
                position: absolute;
                width: auto;
                right: 12px;
                top: 6px;
                
                button {
                  background-color: transparent;
                }

              }

              @media(min-width: 801px) {
                .botao-editar-locacao {
                  position: relative;
                  transform: none !important;
                  transition: none !important;
                  box-shadow: none !important;
                }

                .botao-editar-locacao:hover,
                .botao-editar-locacao:active,
                .botao-editar-locacao:focus {
                  transform: none !important;
                  box-shadow: none !important;
                }
              }
            "
            md={2}
            lg={2}
            xl={2}
          >
            <CardButton className="botao-editar-locacao">
              {window.innerWidth <= 800 ? (
                <ApplicantMobileIconBtn
                  type="button"
                  title="Editar"
                  aria-label="Editar"
                  disabled={this.handleOcultado() === true}
                  onClick={() => {
                    if (this.handleOcultado() !== true) this.props.onEditLocation();
                  }}
                >
                  <Edit />
                </ApplicantMobileIconBtn>
              ) : (
                <span onClick={!this.handleOcultado() && this.props.onEditLocation} style={{fontSize: 10, color: '#152b4e', fontWeight: 400, textDecoration: 'underline', cursor: this.handleOcultado() && 'no-drop'}} >EDITAR</span>
              )}
            </CardButton>
          </BaseColumn>
        </StyledRow>

        <div className='wrapper-box-info'>
          <div className='box-info'>
            <Subtitle>Código do Imóvel<span className='hidden-in-mobile'>:</span></Subtitle>
            <CardText className="realty-info-value" margin="3px 0 5px 8px" title={this.handleOcultado(this.propertyCode)}>{this.handleOcultado(this.propertyCode)}</CardText>
          </div>

          <div className='lateral-bar'></div>

          <div className='box-info hidden-in-mobile'>
            <Subtitle>Tipo de Imóvel:</Subtitle>
            <CardText className="realty-info-value" margin="3px 0 5px 8px" title={this.handleOcultado(this.tipoDeImovel())}>{this.handleOcultado(this.tipoDeImovel())}</CardText>
          </div>

          <div className='box-info'>
            <Subtitle>Aluguel + Encargos<span className='hidden-in-mobile'>:</span></Subtitle>
            <CardText className="realty-info-value" margin="3px 0 5px 8px" title={this.handleOcultado(this.getLocationValue())}>{this.handleOcultado(this.getLocationValue())}</CardText>
          </div>

          <div className='lateral-bar'></div>
          
          <div className='box-info'>
            <Subtitle>Status <span className='hidden-in-mobile'>do pedido:</span></Subtitle>
            <CardText className="realty-info-value" margin="3px 0 5px 8px" title={this.handleOcultado(this.props.infos.status)}>{this.handleOcultado(this.props.infos.status)}</CardText>
          </div>
        </div>
      </StyledRealtyCard>
    );
  }
}

export default RealtyCard;
